import React, { FC, useRef } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { UserRole } from "@green0meter/api-client";

import { VSME_CONFIG } from "./config";

import { VsmeGuide, VsmeRecommendations, VsmeMyUploads } from "@components/main/vsme";
import WelcomeBannerContainer from "@components/main/vsme/hub/WelcomeBanner";
import CollectData from "@components/main/vsme/hub/CollectData/CollectData";
import ReportsContainer from "@components/main/vsme/hub/Reports";
import Overview from "@components/main/vsme/hub/Overview";
import { Grid } from "@components/base";
import { DemoDataAlert } from "@components/common";
import { useUserStore } from "@store/user";

const VsmeHubPage: FC = () => {
  const { t } = useTranslation();
  const reportsRef = useRef<HTMLDivElement>(null);
  const uploadsRef = useRef<HTMLDivElement>(null);
  const { user } = useUserStore();

  const isNotRespondent = user?.role !== UserRole.Respondent;
  const isNotViewer = user?.role !== UserRole.Viewer && user?.role !== UserRole.Auditor;

  return (
    <Box mb={6}>
      <Grid container spacing={3}>
        <WelcomeBannerContainer
          title={t(VSME_CONFIG.welcomeBanner.titleKey)}
          text={t(VSME_CONFIG.welcomeBanner.textKey)}
          color={VSME_CONFIG.welcomeBanner.color}
          icon={VSME_CONFIG.welcomeBanner.icon}
        />
        {isNotViewer && (
          <Grid size={12}>
            <VsmeGuide
              refs={{
                reportsRef,
                uploadsRef,
              }}
            />
          </Grid>
        )}
        {isNotViewer && (
          <Grid size={12}>
            <CollectData
              formBaseType={VSME_CONFIG.formBaseType}
              titleKey={t(VSME_CONFIG.collectData.titleKey)}
              descriptionKey={t(VSME_CONFIG.collectData.descriptionKey)}
              color={VSME_CONFIG.collectData.color}
              icon={VSME_CONFIG.collectData.icon}
              buttonTextKey={t(VSME_CONFIG.collectData.buttonTextKey)}
              noFormsTextKey={t(VSME_CONFIG.collectData.noFormsTextKey)}
            />
          </Grid>
        )}
        {isNotRespondent && isNotViewer && (
          <Grid size={12} ref={reportsRef}>
            <ReportsContainer
              formBaseType={VSME_CONFIG.formBaseType}
              title={t(VSME_CONFIG.reports.titleKey)}
              type={VSME_CONFIG.reports.type}
              noReportsText={t(VSME_CONFIG.reports.noReportsTextKey)}
              fillFormText={t(VSME_CONFIG.reports.fillFormTextKey)}
            />
          </Grid>
        )}
        {isNotRespondent && isNotViewer && <DemoDataAlert />}
        {isNotRespondent && (
          <Grid size={12}>
            <Overview
              title={t(VSME_CONFIG.overview.titleKey)}
              dashboardPath={VSME_CONFIG.overview.dashboardPath}
              viewDashboardText={t(VSME_CONFIG.overview.viewDashboardTextKey)}
              reportPageId={VSME_CONFIG.overview.reportPageId}
            />
          </Grid>
        )}
        {isNotRespondent && isNotViewer && (
          <Grid size={12}>
            <VsmeRecommendations />
          </Grid>
        )}
        {isNotViewer && (
          <Grid size={{ md: 6, xs: 12 }} ref={uploadsRef}>
            <VsmeMyUploads />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default VsmeHubPage;
